import { render, staticRenderFns } from "./ContactTableElement.vue?vue&type=template&id=195edc5b&scoped=true"
import script from "./ContactTableElement.ts?vue&type=script&lang=ts&external"
export * from "./ContactTableElement.ts?vue&type=script&lang=ts&external"
import style0 from "./ContactTableElement.vue?vue&type=style&index=0&id=195edc5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195edc5b",
  null
  
)

export default component.exports